import mainCaller, { pilaAuthUser } from './mainCaller';

export function authUser({ password, username }) {
  return pilaAuthUser(password, username);
}

export async function getUserById(id, token) {
  return await mainCaller(`admin/api/v1/members/${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  }).catch(error => {
    console.log(error);
  });
}

export async function getUserTickets(id, token, query) {
  return await mainCaller(`admin/api/v1/members/${id}/tickets?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  }).catch(error => {
    console.log(error);
  });
}

export async function getGeneralProducts(id, token, branchId) {
  return await mainCaller(`admin/api/v1/members/${id}/product-passes?branchId=${branchId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  }).catch(error => {
    console.log(error);
  });
}

// 라커 이용권 기간 변경
export async function updateLockerPassDate(memberId, memberLockerPassId, data, token) {
  return await mainCaller(
    `admin/api/v1/members/${memberId}/locker-passes/${memberLockerPassId}/date`,
    'PUT',
    data,
    {
      Authorization: `Bearer ${token}`,
    },
  );
}

// 기간상품 이용권 기간 변경
export async function updateProductPassDate(memberId, memberProductPassId, data, token) {
  return await mainCaller(
    `admin/api/v1/members/${memberId}/product-passes/${memberProductPassId}/date`,
    'PUT',
    data,
    {
      Authorization: `Bearer ${token}`,
    },
  );
}

//사용자 수강권 정보 조회.
export async function getUserTicketOnly(id, token, query) {
  return await mainCaller(`admin/api/v1/members/${id}/get/tickets?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  }).catch(error => {
    console.log(error);
  });
}
export async function getUserLessons(id, query, token) {
  return await mainCaller(`admin/api/v1/members/${id}/reservations?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}
export async function getUserAttendance(id, query, token) {
  return await mainCaller(`admin/api/v1/members/${id}/attendances?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}
export async function getUserLessonsHistory(id, query, token) {
  return await mainCaller(`admin/api/v1/members/${id}/lesson/history?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 예약 한 건의 상태 변경 이력 — 누가 예약·출석·결석·취소했는지 순서대로
export async function getReservationEvents(memberId, reservationId, token) {
  return await mainCaller(`admin/api/v1/members/${memberId}/lesson/history/${reservationId}/events`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getUserAttendHistory(query, token) {
  return await mainCaller(`admin/api/v1/members/attend/history?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getCenterUserAttendHistory(query, token) {
  return await mainCaller(`admin/api/v1/members/center/attend/history?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 입장내역 통계 (#94). 목록과 같은 파라미터를 쓰되 page/limit 은 보내지 않는다.
export async function getCenterUserAttendStatistics(query, token) {
  return await mainCaller(`admin/api/v1/members/center/attend/statistics?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getUserExtraData(data, token) {
  return await mainCaller(`admin/user/info/`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  }).catch(error => {
    console.log(error);
  });
}

export async function updateUserById(data, id) {
  return await mainCaller(`admin/api/v1/members/${id}`, 'PUT', data, {
    'Content-type': 'multipart/form-data',
  });
}

// 회원 메모 저장 (지점별 1건) — 응답: { memo, memoUpdatedAt, memoUpdatedByName }
// data: { branchId, memo }
export async function updateMemberMemo(memberId, data, token) {
  return await mainCaller(`admin/api/v1/members/${memberId}/memo`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}

// 회원 메모 목록 조회
export async function getMemberMemos(memberId, branchId, token) {
  return await mainCaller(`admin/api/v1/members/${memberId}/memos?branchId=${branchId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 회원 메모 추가
export async function addMemberMemo(memberId, data, token) {
  return await mainCaller(`admin/api/v1/members/${memberId}/memos`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

// 회원 메모 수정
export async function updateMemberMemoById(memberId, memoId, data, token) {
  return await mainCaller(`admin/api/v1/members/${memberId}/memos/${memoId}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}

// 회원 메모 삭제
export async function deleteMemberMemo(memberId, memoId, token) {
  return await mainCaller(`admin/api/v1/members/${memberId}/memos/${memoId}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function findUsersByName(type, name) {
  return await mainCaller(`api/findUserLike/${name}`, 'POST', null, {}).catch(error => {
    console.log(error);
  });
}

export async function deleteUserById(id, token) {
  return await mainCaller(`admin/deleteUser/${id}`, 'POST', null, {
    Authorization: `Bearer ${token}`,
  }).catch(error => {
    console.log(error);
  });
}

export async function getUserTicketsById(id, token) {
  return await mainCaller(`admin/findByUserId/${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getTotalPayment(id, token) {
  return await mainCaller(`admin/api/v1/members/${id}/total-order`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getPaymentHistory(id, query, token) {
  return await mainCaller(`admin/api/v1/members/${id}/orders?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getUserPaymentDetail(id, token) {
  return await mainCaller(`admin/api/v1/members/orderdetail/${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function createUser(data) {
  return await mainCaller(`admin/api/v1/members`, 'POST', data, {
    'Content-type': 'multipart/form-data',
  });
}
export async function checkUserName(data) {
  return await mainCaller(`admin/api/v1/auth/check/username`, 'POST', data, {});
}

export async function getInbodyData(id, token) {
  return await mainCaller(`admin/api/v1/members/${id}inbody`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function updateExpireDateExtend(data) {
  return await mainCaller(`admin/api/v1/members/expire-date/extend`, 'PUT', data, {
    'Content-type': 'application/json',
  });
}

// 보호자 등록
export async function registerGuardian(memberId, data, token) {
  return await mainCaller(`admin/api/v1/members/${memberId}/guardians`, 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// 보호자 목록 조회
export async function getGuardianList(memberId, token) {
  return await mainCaller(`admin/api/v1/members/${memberId}/guardians`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 보호자 수정
export async function updateGuardian(memberId, guardianId, data, token) {
  return await mainCaller(`admin/api/v1/members/${memberId}/guardians/${guardianId}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// 보호자 삭제
export async function deleteGuardian(memberId, guardianId, token) {
  return await mainCaller(`admin/api/v1/members/${memberId}/guardians/${guardianId}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
}
